import { configureStore } from '@reduxjs/toolkit';
import paintingsReducer from './services/paintingsSlice';
import adminReducer, { clearAdmin } from "./services/adminSlice";
import { onUnauthorized } from '../api/authEvents';


// middleware/localStorage.js

export const localStorageMiddleware = ({ getState }) => next => action => {
    const result = next(action);
    const admin = getState().adminState.admin;

    if (admin) {
        localStorage.setItem('admin', JSON.stringify(admin));
    } else {
        localStorage.removeItem('admin');
    }

    return result;
};

export const reHydrateStore = () => {
    const adminLocalStorage = localStorage.getItem('admin');

    if (adminLocalStorage) {
        return {
            adminState: {
                admin: JSON.parse(adminLocalStorage),
            },
        };
    }

    return undefined;
};

const store = configureStore({
    reducer: {
        paintingsState: paintingsReducer,
        adminState: adminReducer
    },
    preloadedState: reHydrateStore(),
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware),
});

// Реакция на недействительную admin-сессию (401), пришедшую из axiosApi.
// Игнорируем, если сессии нет (анонимный посетитель публичной части).
// admin=null → localStorageMiddleware удалит 'admin', а PrivateRoute/
// AdminDashboard сами уведут на /login.
onUnauthorized(() => {
    if (!store.getState().adminState.admin) {
        return;
    }
    store.dispatch(clearAdmin());
    localStorage.removeItem('admin');
});

export default store;